import { loadTranslations } from 'owa-shared-localization';
import type stringIds from './locale/localizedStringIds.json';
import type { Culture, LocalizationFunction } from 'owa-shared-localization';

export type OwaTimeformatLocalizedStringResourceId = keyof typeof stringIds;

let translationFunction: LocalizationFunction<OwaTimeformatLocalizedStringResourceId> | undefined;

export function getLocalizedString(resourceId: OwaTimeformatLocalizedStringResourceId): string {
    if (!process.env.JEST_WORKER_ID) {
        if (!translationFunction) {
            throw new Error('Localization has not yet been initialized');
        }

        return translationFunction(resourceId);
    } else {
        return resourceId; // so test cases can be written without needing to mock date/time format functions
    }
}

export async function initializeTranslations(culture: Culture): Promise<void> {
    if (process.env.__OWA_LOCALIZE__) {
        throw new Error('Do not initialize with culture within Outlook Web');
    } else {
        translationFunction = await loadTranslations(
            culture,
            c => import(`./locale/${c.toLowerCase()}.locstrings.json`)
        );
    }
}

export function initializeTranslationsWithFunc(
    localizationFunction: LocalizationFunction<OwaTimeformatLocalizedStringResourceId>
): void {
    translationFunction = localizationFunction;
}
